import { BoxProps } from '@jfs/ui-new'

export const styles = {
  container: {
    backgroundColor: 'WHITE',
    shadowOffset: { width: -2, height: 3 },
    shadowRadius: 6,
    shadowColor: 'GRAY_SHADOW',
    borderRadius: 8,
    h: '100%',
    zIndex: 4,
    marginHorizontal: 16,
    p: 16,
    pt: 0,
    borderBottomWidth: 1,
    borderBottomColor: 'WHITE30',
    justifyContent: 'space-between',
  } as BoxProps,
}
